import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";

import Modal from "../../components/Modal";
import Nodata from "../../components/Nodata";

import useStore from "../../store";

import api from "../../services/api";

export default () => {
  const [incentives, setIncentives] = useState();
  const [filters, setFilters] = useState({});

  const { user } = useStore();

  useEffect(() => {
    getIncentives();
  }, [filters]);

  const getIncentives = async (e) => {
    try {
      if (user.role !== "admin") filters.user_id = user.id;
      const { data } = await api.post("incentive/search", filters);
      setIncentives(data.incentives);
    } catch (error) {
      console.error(error);
    }
  };

  const handleDelete = async (incentive) => {
    try {
      if (!window.confirm("Are you sure ?")) return;
      const { data } = await api.remove(`incentive&id=${incentive.id}`);
      await getIncentives();
      toast.success("Successfully deleted !");
    } catch (e) {
      console.log(e);
    }
  };

  if (!incentives) return <div className="p-5 text-center">Loading...</div>;

  return (
    <div className="p-5">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold">Incentives</h1>
      </div>

      <div className="grid grid-cols-3 gap-4 my-4">
        <input
          type="search"
          placeholder="Search by name"
          value={filters.search}
          onChange={(e) => setFilters({ ...filters, search: e.target.value })}
          className="block w-full rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
          required
        />
      </div>

      <div className="bg-white shadow-lg rounded-lg p-6">
        <table className="w-full text-left border-collapse my-5">
          <thead className="text-sm text-gray-400 border-b">
            <tr>
              <th className="py-2">User</th>
              <th className="py-2">Amount</th>
              <th className="py-2">Comments</th>
              <th className="py-2">Customer</th>
              <th className="py-2">Date</th>
              <th className="py-2 text-right">Actions</th>
            </tr>
          </thead>
          <tbody className="text-sm">
            {incentives.map((incentive) => (
              <tr
                className="hover:bg-gray-50 border-b"
                // onClick={() => navigate(`/incentive/${incentive.id}`)}
              >
                <td className="p-2 py-3">{incentive.user_name}</td>
                <td className="p-2 py-3">
                  {incentive.amount.toLocaleString()} PKR
                </td>
                <td className="p-2 py-3">{incentive.comment}</td>
                <td className="p-2 py-3">{incentive.customer_name}</td>
                <td className="p-2 py-3">{incentive.created_at}</td>
                <td>
                  <div className="flex justify-end">
                    {user.role === "admin" && (
                      <button
                        title="Delete"
                        onClick={async () => await handleDelete(incentive)}
                        className="cursor-pointer bg-red-500 hover:bg-red-700 text-white p-2.5 rounded ml-1 print:hidden"
                      >
                        <AiOutlineDelete />
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {!incentives?.length && <Nodata />}
      </div>
    </div>
  );
};

const Updateincentive = ({ incentive, onChange, customer }) => {
  const [values, setValues] = useState(incentive);
  const [isOpen, setIsOpen] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.put("incentive", values);
      await onChange();
      toast.success("Updated!");
      setIsOpen(false);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <button
        title="Edit"
        onClick={() => setIsOpen(true)}
        className="cursor-pointer bg-blue-500 hover:bg-blue-700 text-white p-2.5 rounded mr-1"
      >
        <AiOutlineEdit />
      </button>

      <Modal
        title="Update incentive"
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      >
        <form onSubmit={handleSubmit}>
          {/* Section 1: Personal Details */}
          <div className="grid gap-6">
            <div>
              <label
                htmlFor="type"
                className="block text-sm font-medium text-gray-700"
              >
                incentive type
              </label>
              <select
                id="type"
                className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
                value={values.type}
                onChange={(e) =>
                  setValues({
                    ...values,
                    type: e.target.value,
                    description: e.target.value,
                  })
                }
              >
                <option value="">Select</option>
                {customer?.services?.map((service) => (
                  <option value={service.name}>{service.name}</option>
                ))}
                <option value="Other">Other</option>
              </select>
              {customer?.services?.find((s) => s.name === values.type) && (
                <p className="text-xs mt-2 text-gray-500">
                  Service fee:{" "}
                  {customer?.services
                    ?.find((s) => s.name === values.type)
                    .fee.toLocaleString()}{" "}
                  PKR
                </p>
              )}
            </div>

            {values.type === "Other" && (
              <div>
                <label
                  htmlFor="description"
                  className="block text-sm font-medium text-gray-700"
                >
                  Description
                </label>
                <input
                  type="text"
                  id="description"
                  value={values.description}
                  onChange={(e) =>
                    setValues({ ...values, description: e.target.value })
                  }
                  placeholder="Enter description"
                  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
                  required
                />
              </div>
            )}
            <div>
              <label
                htmlFor="amount"
                className="block text-sm font-medium text-gray-700"
              >
                Amount
              </label>
              <input
                type="number"
                id="amount"
                value={values.amount}
                onChange={(e) =>
                  setValues({ ...values, amount: e.target.value })
                }
                placeholder="Enter amount"
                className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
                required
              />
            </div>
            <div>
              <label
                htmlFor="method"
                className="block text-sm font-medium text-gray-700"
              >
                incentive Method
              </label>
              <select
                id="method"
                className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
                value={values.method}
                onChange={(e) =>
                  setValues({ ...values, method: e.target.value })
                }
              >
                <option value="">Select</option>
                <option value="ONLINE">Online</option>
                <option value="CASH">Cash</option>
              </select>
            </div>
          </div>

          {/* Submit Button */}
          <div className="flex items-center space-x-2 mt-5">
            <button
              type="submit"
              className="bg-black text-sm text-white px-6 py-2 rounded-md hover:bg-gray-900 transition"
            >
              Submit
            </button>
          </div>
        </form>
      </Modal>
    </>
  );
};
